import Vue from 'vue';
import Vuex from 'vuex';
import yuShang from '@/views/20211226WLZJ/store';
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    pointOut: false,
  },
  mutations: {
    changePointOut(state, data) {
      state.pointOut = data;
    },
  },
  actions: {},
  modules: { yuShang },
});
